import * as React from "react";

const LogoChatsbrook = () => {

  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x={0}
      y={0}
      viewBox="0 0 418.3 129.8"
      style={{
        enableBackground: "new 0 0 418.3 129.8",
      }}
      xmlSpace="preserve"
      className={"h-32"}
    >
      <style>
        {
          ".st2,.st3{fill:#fff}.st3{clip-path:url(#SVGID_4_)}.st4{clip-path:url(#SVGID_6_)}.st4,.st5,.st6{fill:#db8732}.st6{clip-path:url(#SVGID_8_)}"
        }
      </style>
      <defs>
        <path id="SVGID_1_" d="M0 0h418.3v129.8H0z"/>
      </defs>
      <clipPath id="SVGID_2_">
        <use
          xlinkHref="#SVGID_1_"
          style={{
            overflow: "visible",
          }}
        />
      </clipPath>
      <path
        d="M2.5 127.3h413.3V2.5H2.5v124.8m415.8 2.5H0V0h418.3v129.8"
        style={{
          clipPath: "url(#SVGID_2_)",
          fill: "#9ea09e",
        }}
      />
      <path
        d="M30.8 45.1c0-9.2 6.9-14.9 15.1-14.9 3.6 0 7.5 1.2 9.9 3v3.9c-2.3-2.1-5.5-3.8-9.9-3.8-6.6 0-11.2 4.6-11.2 11.7s4.7 11.7 11.2 11.7c4.4 0 7.6-1.7 9.9-3.8v3.9c-2.4 1.8-6.3 3-9.9 3-8.1.1-15.1-5.5-15.1-14.7"
        style={{
          clipPath: "url(#SVGID_2_)",
          fill: "#fff",
        }}
      />
      <path
        className="st2"
        d="M70.7 30.8h3.8v11.9h15.7V30.8H94v28.5h-3.8V45.9H74.5v13.4h-3.8zM125.4 48.2l-5-11.7-5 11.7h10zm-6.1-17.4h2.5L134 59.3h-3.9l-3.4-8h-12.5l-3.4 8h-3.7l12.2-28.5zM150.7 34h-10.1v-3.2h24V34h-10.1v25.3h-3.8z"
      />
      <defs>
        <path id="SVGID_3_" d="M0 0h418.3v129.8H0z"/>
      </defs>
      <clipPath id="SVGID_4_">
        <use
          xlinkHref="#SVGID_3_"
          style={{
            overflow: "visible",
          }}
        />
      </clipPath>
      <path
        className="st3"
        d="m176.3 56.5.9-3.5c1.7 1.9 4.6 3.9 8.6 3.9 3.4 0 6-1.9 6-5 0-2.9-1.4-4.5-6.7-5.9-5.4-1.4-7.9-4.3-7.9-8.3 0-4 3.3-7.4 9.2-7.4 3.3 0 6.2 1.3 7.7 2.6l-.9 3c-1.9-1.4-4.6-2.5-6.9-2.5-3.6 0-5.6 1.7-5.6 4.3 0 2 1.3 3.8 5.7 4.9 6.1 1.6 8.9 4.3 8.9 9 0 5.6-4.7 8.4-9.5 8.4-4.7-.1-7.9-1.9-9.5-3.5M219.7 56.1c4.3 0 5.6-2.6 5.6-5.2s-1.3-5.2-5.6-5.2h-6.1v10.4h6.1zm-.5-13.5c3.6 0 4.7-2.1 4.7-4.3 0-2.2-1.1-4.3-4.7-4.3h-5.6v8.6h5.6zm-9.4-11.8h9.4c5.8 0 8.3 3.4 8.3 7.5 0 2.2-1.4 4.4-3 5.6 2.8 1.2 4.5 4.1 4.5 7.1 0 4.6-2.8 8.4-9.3 8.4h-9.9V30.8zM252.8 44.3c4.3 0 5.6-2.6 5.6-5.2s-1.3-5.2-5.6-5.2h-5.6v10.4h5.6zm-9.4-13.5h9.4c6.5 0 9.3 3.8 9.3 8.4 0 3.7-1.8 6.8-5.9 7.9l8.6 12.2h-4.4l-8.2-11.8h-5.1v11.8h-3.8V30.8zM301.9 45.1c0-6.9-4.7-11.9-11.2-11.9-6.6 0-11.2 4.9-11.2 11.9 0 6.9 4.7 11.9 11.2 11.9 6.5-.1 11.2-5.1 11.2-11.9m-26.4 0c0-8.7 6.4-15.1 15.1-15.1s15.1 6.3 15.1 15.1-6.4 15.1-15.1 15.1c-8.6-.1-15.1-6.4-15.1-15.1M345.2 45.1c0-6.9-4.7-11.9-11.2-11.9-6.6 0-11.2 4.9-11.2 11.9 0 6.9 4.7 11.9 11.2 11.9 6.5-.1 11.2-5.1 11.2-11.9m-26.3 0c0-8.7 6.4-15.1 15.1-15.1s15.1 6.3 15.1 15.1-6.4 15.1-15.1 15.1c-8.7-.1-15.1-6.4-15.1-15.1"
      />
      <path
        className="st2"
        d="M363.7 30.8h3.8v13.5l13.2-13.5h4.4l-13.6 13.6L387 59.3h-5.1l-14.4-14v14h-3.8z"
      />
      <defs>
        <path id="SVGID_5_" d="M0 0h418.3v129.8H0z"/>
      </defs>
      <clipPath id="SVGID_6_">
        <use
          xlinkHref="#SVGID_5_"
          style={{
            overflow: "visible",
          }}
        />
      </clipPath>
      <path
        className="st4"
        d="M36.2 90.3h-3V96h3c2.3 0 3.2-1.2 3.2-2.9 0-1.6-.9-2.8-3.2-2.8m-3.1-2.5h2.8c1.8 0 2.6-1 2.6-2.4 0-1.3-.8-2.4-2.6-2.4h-2.8v4.8zm3.7 10.8h-7.4V80.4h7.1c3.9 0 5.5 2.2 5.5 4.8 0 1.4-.9 2.9-1.9 3.6 1.8.8 2.9 2.6 2.9 4.5-.1 2.9-1.8 5.3-6.2 5.3M61.7 88.8h2.9c2.3 0 3.1-1.2 3.1-2.8 0-1.6-.8-2.9-3.1-2.9h-2.9v5.7zm11.4 9.8H69l-5-7.2h-2.3v7.2H58V80.4h7.2c4.3 0 6.2 2.5 6.2 5.5 0 2.5-1.3 4.4-3.6 5.1l5.3 7.6z"
      />
      <path
        className="st5"
        d="m95.1 85-2.7 6.6h5.4L95.1 85zm5.5 13.6-1.8-4.5h-7.4l-1.8 4.5H86l7.7-18.2h2.9l7.7 18.2h-3.7zM131.6 98.6l-9.5-12v12h-3.3V80.4h2.5l9.6 12.1V80.4h3.3v18.2z"
      />
      <defs>
        <path id="SVGID_7_" d="M0 0h418.3v129.8H0z"/>
      </defs>
      <clipPath id="SVGID_8_">
        <use
          xlinkHref="#SVGID_7_"
          style={{
            overflow: "visible",
          }}
        />
      </clipPath>
      <path
        className="st6"
        d="M156.6 83.4H154v12.3h2.5c5 0 6.7-2.5 6.7-6.1.1-3.7-1.7-6.2-6.6-6.2m.1 15.2h-6.4V80.4h6.4c7.3 0 10.3 4.1 10.3 9.1s-3 9.1-10.3 9.1M206 83.1h-2.6v6.3h2.6c2.4 0 3.2-1.4 3.2-3.2.1-1.7-.8-3.1-3.2-3.1m.6 8.9h-3.2v6.6h-3.7V80.4h6.9c4.4 0 6.3 2.7 6.3 5.8.1 3.2-1.9 5.8-6.3 5.8"
      />
      <path
        className="st5"
        d="m233.3 85-2.7 6.6h5.4l-2.7-6.6zm5.6 13.6-1.8-4.5h-7.4l-1.8 4.5h-3.6l7.7-18.2h2.9l7.7 18.2h-3.7z"
      />
      <defs>
        <path id="SVGID_9_" d="M0 0h418.3v129.8H0z"/>
      </defs>
      <clipPath id="SVGID_10_">
        <use
          xlinkHref="#SVGID_9_"
          style={{
            overflow: "visible",
          }}
        />
      </clipPath>
      <path
        d="M260.7 88.8h2.9c2.3 0 3.1-1.2 3.1-2.8 0-1.6-.8-2.9-3.1-2.9h-2.9v5.7zm11.3 9.8h-4l-5-7.2h-2.3v7.2H257V80.4h7.2c4.3 0 6.2 2.5 6.2 5.5 0 2.5-1.3 4.4-3.6 5.1l5.2 7.6z"
        style={{
          clipPath: "url(#SVGID_10_)",
          fill: "#db8732",
        }}
      />
      <path
        className="st5"
        d="M294.2 83.3v15.3h-3.7V83.3h-6.2v-2.9h16v2.9zM327.6 98.6l-9.5-12v12h-3.3V80.4h2.6l9.5 12.1V80.4h3.3v18.2zM346.4 98.6V80.4h11.8v2.9h-8.1v4.3h6.6v2.9h-6.6v5.3h8.1v2.8z"
      />
      <defs>
        <path id="SVGID_11_" d="M0 0h418.3v129.8H0z"/>
      </defs>
      <clipPath id="SVGID_12_">
        <use
          xlinkHref="#SVGID_11_"
          style={{
            overflow: "visible",
          }}
        />
      </clipPath>
      <path
        d="M377.5 88.8h2.9c2.3 0 3.1-1.2 3.1-2.8 0-1.6-.8-2.9-3.1-2.9h-2.9v5.7zm11.4 9.8h-4.1l-5-7.2h-2.3v7.2h-3.7V80.4h7.2c4.3 0 6.2 2.5 6.2 5.5 0 2.5-1.3 4.4-3.6 5.1l5.3 7.6z"
        style={{
          clipPath: "url(#SVGID_12_)",
          fill: "#db8732",
        }}
      />
    </svg>
  )
}


export default LogoChatsbrook;